export default import.meta.ROLLDOWN_FILE_URL_sA1Pe$aP5_D8DYp0gfXE7g